import { css } from 'styled-components';
import styled from 'styled-components';
import { theme, typography } from 'dab-component-lib';

export const { basic } = theme.palettes;
export const { status } = theme.palettes;

export const MediaStyle = {
  smOnly: (...args) => css`
    @media all and (max-width: 767px) {
      ${ css(...args) }
    }
  `,
  sm: (...args) => css`
    @media all and (min-width: 575px) {
      ${ css(...args) }
    }
  `,
  md: (...args) => css`
    @media all and (min-width: 768px) {
      ${ css(...args) }
    }
  `,
  lg: (...args) => css`
    @media all and (min-width: 992px) {
      ${ css(...args) }
    }
  `,
  xl: (...args) => css`
    @media all and (min-width: 1200px) {
      ${ css(...args) }
    }
  `
};

export const SpanStyle = styled.span `
  color: green;
  display: flex;
  flex-direction: row;
  cursor: pointer;
  div {
    margin-left: 15px;
  }
`;



export const GridContainerStyle = styled.div`
  padding: 0 10px;
  ${ MediaStyle.md`
    max-width: 1182px;
    margin: 0 auto;
  ` }
`;

export const GridRowStyle = styled.div`
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: ${props => props.nowrap ? 'nowrap' : 'wrap'};
  align-items: ${props => props.center ? 'center' : 'stretch'};
  justify-content: ${props => props.right ? 'flex-end' : 'space-between'};
  margin: ${props => props.full ? '0' : '0 -5px'};
  box-sizing: border-box;
`;

export const GridColStyle = styled.div`
  padding: ${props => props.full ? '0' : '10px 5px'};
  position: relative;
  box-sizing: border-box;
  ${ MediaStyle.md`
    ${props => props.logo && `
      flex-grow: 2;
    `};

    ${props => props.search && `
      flex-grow: 1;
      & > div {
        display: flex;
        align-items: flex-end;
        & > div {
          width: 100%;
        }
      }
    `};

  ` }

  ${ MediaStyle.smOnly`
    ${props => props.search && `
      order: 3;
      width: 100%;
      padding-top: 0;
    `};
  ` }
`;


export const LoadingStyle = styled.div`
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${props => props.small && `
    min-height: none;
    padding: 15px 0;
  `};
`;

export const ErrorStyle = styled.div`
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BackStyle = styled.a`
  ${typography.Body1};
  font-weight: bold;
  color: ${basic.secondary};
  cursor: pointer;
`;

export const PageWrapperStyle = styled.div`
  ${ MediaStyle.smOnly`
    ${props => props.openMenu && `
      &:before {
        content: '';
        display: block;
        background: rgba(0, 70, 21, .9);
        height: 100vh;
        width: 100vw;
        position: fixed;
        top: 0;
        left: 0;
        z-index: ${theme.zIndex.modal};
      }
     `}
  `}
`;

export const PageHeaderWrapperStyle = styled.div`
  margin: ${props => props.bigger ? '15px 0 30px' : '15px 0'};
  ${ MediaStyle.md`
    margin: ${props => props.bigger ? '30px 0 50px' : '30px 0'};
  ` }
`;

export const PageContainterStyle = styled.div`
  ${ MediaStyle.md`
    min-height: calc(100vh - 167px);
  ` }
`;

export const HiddenMobileStyle = styled.div`
  ${ MediaStyle.smOnly`
    display: none;
  `}
`;



// WEBPACK FOOTER //
// ./src/utils/style-utils.js